import React from 'react';
import { Sun, Moon, SunMoon } from 'lucide-react';
import { useTheme, ThemePref } from '../services/theme';

const CHOICES: { value: ThemePref; label: string; icon: typeof Sun; hint: string }[] = [
  { value: 'light', label: 'Light', icon: Sun,     hint: 'Always light' },
  { value: 'auto',  label: 'Auto',  icon: SunMoon, hint: 'Match this phone or computer' },
  { value: 'dark',  label: 'Dark',  icon: Moon,    hint: 'Always dark' },
];

/**
 * Light / Auto / Dark. `tone="menu"` sits on the admin sidebar (magenta in
 * light, plum in dark); the plain tone sits on an ordinary white card.
 */
export default function ThemeSwitch({ tone = 'plain' }: { tone?: 'plain' | 'menu' }) {
  const { pref, setPref } = useTheme();
  const wrap = tone === 'menu'
    ? 'bg-black/15 dark:bg-snow/10'
    : 'bg-gray-100 border border-gray-200';
  const on = 'bg-white text-gray-900 shadow-soft dark:bg-brand-600 dark:text-black';
  const off = tone === 'menu'
    ? 'text-black/80 hover:bg-white/25 dark:text-gray-700 dark:hover:bg-snow/10'
    : 'text-gray-600 hover:text-gray-900';
  return (
    <div role="radiogroup" aria-label="Screen colour" className={`flex rounded-2xl p-1 gap-1 ${wrap}`}>
      {CHOICES.map(c => {
        const active = pref === c.value;
        return (
          <button key={c.value} type="button" role="radio" aria-checked={active} title={c.hint}
            onClick={() => setPref(c.value)}
            className={`press flex-1 min-w-0 flex items-center justify-center gap-1.5 rounded-xl px-2 ${tone === 'menu' ? 'py-1.5' : 'py-2'} text-xs font-bold ${active ? on : off}`}>
            <c.icon className="h-4 w-4 flex-shrink-0" />{c.label}
          </button>
        );
      })}
    </div>
  );
}
